import {
    IAngularEvent,
    IComponentController,
    IComponentOptions,
} from 'angular';
import { ISeries } from '../../../../tn.fonts/SeriesService';
import { IFontFamilyModel } from '../../../classes';
import template from './family-specimen-heading.html';

export class FamilyHeadingComponentBindings {
    // style to show the heading for.
    family?: IFontFamilyModel;

    // canonical series entity, TODO: move this to the family model.
    canonicalSeries?: ISeries;

    // show the buy/save buttons.
    showBuyButton = false;
    showSaveButton = false;

    showOpenClose = true;
    onOpenStylesClicked?: (args: { $event: IAngularEvent }) => void = undefined;
    onCloseStylesClicked?: (args: { $event: IAngularEvent }) => void =
        undefined;
}

export class FamilySpecimenHeadingComponent
    extends FamilyHeadingComponentBindings
    implements IComponentController
{
    constructor() {
        super();
    }
    openStyles($event: IAngularEvent): void {
        this.onOpenStylesClicked && this.onOpenStylesClicked({ $event });
    }
    closeStyles($event: IAngularEvent): void {
        this.onCloseStylesClicked && this.onCloseStylesClicked({ $event });
    }
}

export const FamilySpecimenHeadingComponentOptions: IComponentOptions = {
    controller: FamilySpecimenHeadingComponent,
    bindings: {
        family: '<',
        canonicalSeries: '<',
        filteredStyles: '<',
        isOpen: '<',
        showBuyButton: '<',
        showSaveButton: '<',
        showTrialButton: '<',
        showOpenClose: '<?',
        onCloseStylesClicked: '&',
        onOpenStylesClicked: '&',
    },
    template,
};
